export const colors = {
  // Theme Colors
  primary: '#1E49E2',
  'on-primary': '#FFFFFF',
  'primary-hover': '#00338D',
  'primary-border': '#C9D3F8',
  secondary: '#00338D',
  error: '#ED2124',
  'error-hover': '#CE0017',
  success: '#269924',
  info: '#00B8F5',
  warning: '#EEB82A',
  accent: '#7213EA',
  selected: '#1E49E2',
  lightThemeText: '#FFFFFF',
  background: '#F5F6FA',
  launchpadTiles: '#1E49E2',
  launchpadTilesHover: '#00338D',
  'app-header': '#0C233C',
  'on-surface': '#0C233C',
  'on-background': '#0C233C',
  'disabled-bg': '#E5E5E5',
  'disabled-text': '#989898',
  'tab-color': '#63EBDA',
  'nav-drawer-icon': '#666666',
  grey: '#666666',

  'selection-input-border': '#989898',
  'data-table-header-bg': '#B2B2B2',

  // Alerts and snackbar color
  'alert-warning': '#FDF5E0',
  'on-alert-warning': '#795907',
  'alert-error': '#FFEAED',
  'on-alert-error': '#9D0B16',
  'alert-success': '#E6F4E5',
  'on-alert-success': '#014C07',
  'alert-low': '#F6F6F6',
  'on-alert-low': '#0C233C',
  'alert-info': '#C9D3F8',
  'on-alert-info': '#00338D',

  // Chart colors
  standardDefault: '#0C233C',
  standard1: '#00338D',
  standard2: '#1E49E2',
  standard3: '#510DBC',
  standard4: '#7213EA',
  standard5: '#B497FF',
  standard6: '#AB0D82',
  standard7: '#FD349C',
  standard8: '#FFA3DA',
  standard9: '#00B8F5',
  standard10: '#76D2FF',
  standard11: '#ACEAFF',

  // Alert colors
  defaultAlert: '#70B1C7',
  alert1: '#D74A4A',
  alert2: '#EBC058',
  alert3: '#5BC3A2',
  alert4: '#BFCCC8',
  alert5: '#4C8DA3',

  // Others
  hovergray: '#EEEEEE',
  tasksGreen: '#9CD298',
  releaseGreen: '#178718'
};
